import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IOtherUserData } from '../../helpers/types';
import { AppDispatch, StoreState } from '../../redux/store';
import { getOtherUserInfos } from '../../redux/users/usersSlice';

const useFetchOtherUserInfos = (idOrUsername: string | null) => {
  const dispatch = useDispatch<AppDispatch>();
  const {otherUsers, loading, error} = useSelector((state: StoreState) => state.users);
  const [otherUser, setOtherUser] = useState<IOtherUserData | null>(null);

  useEffect(() => {
    if (otherUsers.length === 0 && idOrUsername) {
      dispatch(getOtherUserInfos(idOrUsername));
    } else {
      const user = otherUsers.find((user: IOtherUserData) => user.id === idOrUsername || user.infos.username === idOrUsername);
      if (user) {
        setOtherUser(user);
      } else {
        idOrUsername && dispatch(getOtherUserInfos(idOrUsername));
      }	

    }
  }, [dispatch, idOrUsername, otherUsers]);

  
  return {loading, error, otherUser};
};

export default useFetchOtherUserInfos;

